import { render } from "./emptyImgPc.vue?vue&type=template&id=0f44a0c0&scoped=true"
import script from "./emptyImgPc.vue?vue&type=script&lang=js"
export * from "./emptyImgPc.vue?vue&type=script&lang=js"

import "./emptyImgPc.vue?vue&type=style&index=0&id=0f44a0c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f44a0c0"]])

export default __exports__